import "./FinanceFeatures.scss"

const FinanceFeatures = () => {
    return (
        <>
            <div className="financeFeaturesOuterDiv">
                <div className="financeFeaturesInnerDiv">
                    <div className="financeFeaturesInnerDivRow1">
                        <div className="financeFeaturesInnerDiv1">
                            <button className="financeFeaturesBtn">
                                FEATURES
                            </button>
                        </div>
                    </div>
                    <div className="financeFeaturesInnerDivRow2">
                        <div className="financeFeaturesInnerDiv2">
                            <p id="financeFeaturesHeading">
                                We provide consulting to strategic growth.
                            </p>
                        </div>
                        <div className="financeFeaturesInnerDiv3">
                            <p id="financeFeaturesDescription">
                                Consultez is the destination where early adopters and innovation enthusiasts discover cutting-edge technology
                            </p>
                        </div>
                    </div>
                    <div className="financeFeaturesInnerDivRow3">
                        <div className="financeFeaturesInnerDivCard">
                            <p id="card-title"> Strategic Investments </p>
                            <span class="material-symbols-outlined" id="card-icon"> finance_mode </span>
                            <div id="common-part">
                                <p id="common-line"> Read Out More </p>
                                <span class="material-symbols-outlined" id="arrow-icon"> arrow_outward </span>
                            </div>
                        </div>

                        <div className="financeFeaturesInnerDivCard">
                            <p id="card-title"> Putting Customers First </p>
                            <span class="material-symbols-outlined" id="card-icon"> groups </span>
                            <div id="common-part">
                                <p id="common-line"> Read Out More </p>
                                <span class="material-symbols-outlined" id="arrow-icon"> arrow_outward </span>
                            </div>
                        </div>

                        <div className="financeFeaturesInnerDivCard">
                            <p id="card-title"> Smarter Business Decisions </p>
                           <span class="material-symbols-outlined" id="card-icon"> monitoring </span>
                            <div id="common-part">
                                <p id="common-line"> Read Out More </p>
                                <span class="material-symbols-outlined" id="arrow-icon"> arrow_outward </span>
                            </div>
                        </div>

                        
                        <div className="financeFeaturesInnerDivCard">
                            <p id="card-title"> Driving Innovation With Agile </p>
                           <span class="material-symbols-outlined" id="card-icon"> check_circle </span>
                            <div id="common-part">
                                <p id="common-line"> Read Out More </p>
                                <span class="material-symbols-outlined" id="arrow-icon"> arrow_outward </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FinanceFeatures;